//#region components/combobox_multi_select/combobox_multi_select_constants.js
var e = {
	EXTRA_SMALL: "xs",
	SMALL: "sm",
	DEFAULT: "md"
}, t = {
	xs: "xs",
	sm: "xs",
	md: "sm"
}, n = {
	xs: 1.4,
	sm: -.1,
	md: -.3
}, r = {
	MULTI_SELECT_SIZES: e,
	CHIP_SIZES: t,
	CHIP_TOP_POSITION: n
};
//#endregion
export { t as CHIP_SIZES, n as CHIP_TOP_POSITION, e as MULTI_SELECT_SIZES, r as default };

//# sourceMappingURL=combobox-multi-select-constants.js.map